export const seoKeywords = {
  name: 'keywords',
  content:
    'blockchain, software development, outsourcing, software house, nodejs, solidity, solana, react js, react native, truffle, ethereum',
};

export const dedicatedDevTeamsSeo = {
  title:
    'Flexible & dedicated software development team tailored to your needs | Rumble Fish Software Development',
  meta: [
    seoKeywords,
    {
      name: 'description',
      content:
        'Team of experienced software developers ready to join your project. Frontend engineers | Backend engineers | Fullstack software developers | Blockchain engineers',
    },
  ],
};
